/* eslint-disable react-hooks/rules-of-hooks */
import React, { useCallback, useEffect, useState } from 'react';
import 'moment/locale/pt';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { Box, Button, CircularProgress, FormControl, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import api from '../../../../services/api';
import { FaRegFileExcel, FaUpload } from 'react-icons/fa';
import { enqueueSnackbar } from 'notistack';

export default function NewWorkSheetModal({ onClose, getList }) {
  const user = JSON.parse(localStorage.getItem('user'))
  const [file, setFile] = useState(null);
  const [type, setType] = useState(null);
  const [loadingForm, setLoadingForm] = useState(false);
  const [fileName, setFileName] = useState(null);

  const handleOnCloseModal = () => {
    onClose()
  }

  const handleSubmit = useCallback(
    async (data) => {
      setLoadingForm(true);
      if (file === null) {
        setLoadingForm(false);
        enqueueSnackbar('Selecione uma planilha para upload.', { variant: 'error' });
        return
      }
      if (type === null) {
        setLoadingForm(false);
        enqueueSnackbar('Selecione um tipo.', { variant: 'error' });
        return
      }
      if (fileName === null) {
        setLoadingForm(false);
        enqueueSnackbar('Preencha os campos corretamente.', { variant: 'error' });
        return
      }

      const dataForm = new FormData();
      dataForm.append('file', file);
      dataForm.append('loadProcess', type);
      dataForm.append('fileName', fileName);
      dataForm.append('userName', user.username);

      try {
        await api.post('/tools/saveFileUploaded', dataForm);
        enqueueSnackbar('Cadastro realizado com sucesso!', { variant: 'success' });
        
        setLoadingForm(false);
        setFile(null);
        setType(null);
        getList();
        handleOnCloseModal();
      } catch (error) {
        setLoadingForm(false);
        enqueueSnackbar('Erro ao cadastrar planilha.', { variant: 'error' });
        return
      }
    },
    [file, getList, type, user.username],
  );

  const handleChangeFile = async (event) => {
    if (event) {
      if (event.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        enqueueSnackbar('Somente arquivo excel.', { variant: 'error' });
        setFile(null)
        return
      } else {
        setFile(event)
      }
    }
  }

  const handleAlignment = (event, newAlignment) => {
    setType(newAlignment);
  };

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Cadastrar nova categoria
        </Typography>
      </Box>

      <Box sx={{
        marginTop: '16px',
        marginBottom: '16px',
        marginRight: '32px',
        width: 400,
        minWidth: 400,
        maxHeight: '80%',
        height: '90%',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 2
      }}>

        <Box>
          <label
            id="thumbnail"
            className={file ? 'has-thumbnail' : ''}
          >
            {file ? 
              <div className="divFile" id="divFile">
                <FaRegFileExcel style={{paddingRight: 5}} />
                <span>{file.name}</span>
              </div>
            : 
              <div className="divFile" id="divFile">
                <FaUpload style={{paddingRight: 5}} />
                <span>Escolha o arquivo</span>
              </div>
            }
            <input
              type="file"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={event => handleChangeFile(event.target.files[0])}
            />
          </label>
        </Box>


        <Box sx={{display: 'flex', gap: 2}}>
          <FormControl fullWidth>
            <TextField
              label="Nome da planilha"
              onChange={e => setFileName(e.target.value)}
            />
          </FormControl>
        </Box>

        <Typography variant="h6" component="h2">
          Tipo
        </Typography>

        <Box>
          <ToggleButtonGroup
            value={type}
            exclusive
            onChange={handleAlignment}
            sx={{width: '100%', gap: 2}}
          >
            <ToggleButton sx={{width: '100%'}} value="carga_site">
              Site
            </ToggleButton>
            <ToggleButton sx={{width: '100%'}} value="carga_app">
              Aplicativo
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>

      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button disabled={loadingForm} variant="contained" color={'success'}>
          <Typography color={'#fff'} onClick={() => handleSubmit()}>
            {loadingForm? <CircularProgress color='success' /> : 'Carregar'}
          </Typography>
        </Button>
        <Button disabled={loadingForm} variant="contained" color='error' onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
